// extracted by mini-css-extract-plugin
module.exports = {"select":"font_color_select__24tHM","active":"font_color_active__1paVw"};